import React, { Component, createRef } from "react";
import {
  StyleSheet,
  View,
  Text,
  Dimensions,
  ScrollView,
  TouchableOpacity,
  Modal,
  Pressable,
} from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { getNavigator } from "../../utils";

export default class DropDown extends Component {
  static instances = new Set();

  triggerRef = createRef();

  state = {
    isVisible: false,
    selected: null,
    navigator: getNavigator(),
    menuRect: null,
  };

  UNSAFE_componentWillReceiveProps(nextProps){
    const { options, isMultiple } = this.props;
    if(nextProps.updated != this.props.updated){
      if(isMultiple){
        this.setState({ selected: nextProps.updated });
      }else{
        var opt = options.filter(option => option.id == nextProps.updated);
        if(opt.length > 0){
          this.setState({ selected: opt[0] });
        }
      }
    }
    if (nextProps.openList != this.props.openList) {
      this.setState({ isVisible: nextProps.openList });
    }
    if(nextProps.isDropDownOpened != this.props.isDropDownOpened && !nextProps.isDropDownOpened){
      this.setState({ isVisible: false, menuRect: null });
    }
  }

  componentDidMount() {
    DropDown.instances.add(this);
  }

  measureAndOpen = (openDropDown) => {
    const node = this.triggerRef.current;
    if (!node || typeof node.measureInWindow !== "function") {
      this.setState({ menuRect: { x: 0, y: 0, width: 200, height: 60 } });
      if (openDropDown) openDropDown();
      return;
    }
    requestAnimationFrame(() => {
      node.measureInWindow((x, y, width, height) => {
        this.setState(
          { menuRect: { x, y, width: width || 200, height: height || 60 } },
          () => { if (openDropDown) openDropDown(); }
        );
      });
    });
  };

  closeMenu = (syncParent = true) => {
    this.stopMenuAnchorUpdates();
    const { resetDropDown, isDropDownOpened } = this.props;
    this.setState({ isVisible: false, menuRect: null }, () => {
      if (syncParent && isDropDownOpened && typeof resetDropDown === "function") {
        resetDropDown();
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const showingMenu = this.state.isVisible && !!this.state.menuRect;
    const wasShowingMenu = prevState.isVisible && !!prevState.menuRect;
    if (showingMenu && !wasShowingMenu) {
      this.startMenuAnchorUpdates();
    } else if (!showingMenu && wasShowingMenu) {
      this.stopMenuAnchorUpdates();
    }
  }

  componentWillUnmount() {
    DropDown.instances.delete(this);
    this.stopMenuAnchorUpdates();
  }

  handleTriggerPress = () => {
    const { isVisible } = this.state;
    const { defaultComponent, openDropDown } = this.props;
    if (!defaultComponent) {
      if (!isVisible) {
        this.setState({ isVisible: true }, () => this.measureAndOpen(openDropDown));
      } else {
        this.closeMenu(true);
      }
    }
  };

  openDropdownFromPoint = (pageX, pageY) => {
    if (typeof pageX !== "number" || typeof pageY !== "number") return;
    const others = Array.from(DropDown.instances).filter((instance) => instance !== this);
    if (others.length <= 0) return;
    let opened = false;
    others.forEach((instance) => {
      const node = instance?.triggerRef?.current;
      if (!node || typeof node.measureInWindow !== "function" || opened) return;
      node.measureInWindow((x, y, width, height) => {
        if (opened) return;
        const isWithinX = pageX >= x && pageX <= (x + width);
        const isWithinY = pageY >= y && pageY <= (y + height);
        if (isWithinX && isWithinY) {
          opened = true;
          setTimeout(() => {
            if (typeof instance.handleTriggerPress === "function") {
              instance.handleTriggerPress();
            }
          }, 0);
        }
      });
    });
  };

  handleBackdropPress = (event) => {
    const pageX = event?.nativeEvent?.pageX;
    const pageY = event?.nativeEvent?.pageY;
    this.closeMenu(true);
    this.openDropdownFromPoint(pageX, pageY);
  };

  startMenuAnchorUpdates = () => {
    this.stopMenuAnchorUpdates();
    this._menuAnchorInterval = setInterval(() => {
      if (!this.state.isVisible || !this.state.menuRect) {
        this.stopMenuAnchorUpdates();
        return;
      }
      const node = this.triggerRef.current;
      if (!node || typeof node.measureInWindow !== "function") return;
      node.measureInWindow((x, y, width, height) => {
        const nextRect = { x, y, width: width || 200, height: height || 60 };
        this.setState((prev) => {
          if (!prev.isVisible || !prev.menuRect) return null;
          const p = prev.menuRect;
          if (
            p.x === nextRect.x &&
            p.y === nextRect.y &&
            p.width === nextRect.width &&
            p.height === nextRect.height
          ) {
            return null;
          }
          return { menuRect: nextRect };
        });
      });
    }, 50);
  };

  stopMenuAnchorUpdates = () => {
    if (this._menuAnchorInterval != null) {
      clearInterval(this._menuAnchorInterval);
      this._menuAnchorInterval = null;
    }
  };

  renderOptionsList = (backgroundColor, options, selectedOption, isMultiple) => {
    const { onSelect } = this.props;
    return (
      <ScrollView style={{...styles.options, backgroundColor: backgroundColor ? backgroundColor : '#ffff'}} keyboardShouldPersistTaps="handled">
        {options.map((option, optIdx) => (
          <TouchableOpacity
            style={styles.item}
            key={optIdx}
            onPress={() => {
              var found = -1;
              var selected = [];
              if (typeof selectedOption == "object" && isMultiple) {
                found = selectedOption.findIndex(selectedO => selectedO == option.value);
                selected = selectedOption;
                if (found >= 0) {
                  selected.splice(found, 1);
                } else {
                  selected.push(option.value);
                }
              } else {
                selected = option;
              }
              onSelect(selected);
              this.setState({ selected: selected, isVisible: false, menuRect: null }, () => {
                const { resetDropDown, isDropDownOpened } = this.props;
                if (isDropDownOpened && typeof resetDropDown === "function") {
                  resetDropDown();
                }
              });
            }}
          >
            <Text style={styles.label}>{option.value}</Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    );
  };

  render() {
    const { isVisible, selected, navigator, menuRect } = this.state;
    const { options, initialOption, defaultComponent, openDropDown, backgroundColor, isMultiple } = this.props;
    const selectedOption = selected ? isMultiple ? selected : selected.value : isMultiple ? initialOption : initialOption.value;

    const win = Dimensions.get("window");
    let menuTop = 0;
    let menuMaxHeight = 200;
    if (menuRect) {
      const below = menuRect.y + menuRect.height;
      const spaceBelow = win.height - below - 16;
      const spaceAbove = menuRect.y - 16;
      if (spaceBelow >= 120 || spaceBelow >= spaceAbove) {
        menuTop = below;
        menuMaxHeight = Math.min(200, Math.max(80, spaceBelow));
      } else {
        menuMaxHeight = Math.min(200, Math.max(80, spaceAbove));
        menuTop = Math.max(16, menuRect.y - menuMaxHeight);
      }
    }

    return (
      <View style={{...styles.container, height: isMultiple ? 'auto' : 60}} ref={this.triggerRef} collapsable={false}>
        <TouchableOpacity
          style={ navigator == "safari" ? {...styles.button, backgroundColor: isMultiple ? "#D3D3D3" : 'none' } : {...styles.button, backgroundColor: isMultiple ? "#D3D3D3" : 'none', flex: 1 }}
          onPress={this.handleTriggerPress}
        >
          {
            (selectedOption && typeof selectedOption == "object" && isMultiple) ? 
              <View>
                {
                  selectedOption.map((selected) => {
                    return <Text style={{ ...styles.label, paddingLeft: 5, paddingVertical: 5, width: '100%'}}>{selected}</Text>
                  })
                }
              </View>
            :
            <Text style={styles.label}>{selectedOption}</Text>
          }
          <MaterialCommunityIcons
            name="chevron-down"
            size={30}
            color="#9B9B9B"
            style={styles.icon}
          />
        </TouchableOpacity>

        <Modal
          visible={isVisible && !!menuRect}
          transparent
          //animationType="fade"
          onRequestClose={() => this.closeMenu(true)}
          statusBarTranslucent
        >
          <Pressable style={styles.modalBackdrop} onPress={this.handleBackdropPress} />
          {menuRect ? (
            <View
              style={[
                styles.modalMenu,
                {
                  left: menuRect.x,
                  top: menuTop,
                  width: menuRect.width,
                  maxHeight: menuMaxHeight,
                },
              ]}
              pointerEvents="box-none"
            >
              {this.renderOptionsList(backgroundColor, options, selectedOption, isMultiple)}
            </View>
          ) : null}
        </Modal>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch",
    width: "100%",
    position: "relative",
    overflow: "hidden",
    zIndex: 1,
  },
  modalBackdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0,0,0,0.01)",
  },
  modalMenu: {
    position: "absolute",
    zIndex: 10000,
    elevation: 24,
  },
  button: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderWidth: 1,
    borderColor: "#e7e7e7",
    borderRadius: 5,
    paddingLeft: 10,
    height: 60,
  },
  label: {
    fontSize: 16,
    color: "#333",
    fontWeight: "200",
    fontFamily: "Roboto",
    wordBreak: 'break-all',
    width: '100%'
  },
  icon: {
    width: 30,
    height: 30,
    marginRight: 5,
  },
  options: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#e7e7e7",
    borderRadius: 5,
    borderTopLeftRadius: 0,
    paddingBottom: 5,
    width: "100%",
    maxHeight: 200,
  },
  item: {
    paddingLeft: 10,
    paddingVertical: 10,
  },
});
